<script setup lang="ts">
import { storeToRefs } from 'pinia';
import useLocale from '../composables/useLocale';
import useNavigationStore from '../stores/navigation';
import useBookPagination from '../composables/use-book-pagination';
import { useDisplay } from 'vuetify';

const { pageRange } = useBookPagination();
const { isInitializing, resolutionProgress, isNavigating } = storeToRefs(useNavigationStore());
const { t } = useLocale();
const { xs } = useDisplay();
</script>

<template>
  <div class="page-range-container d-flex align-center min-w-0 ga-3" data-testid="bp-page-range-display">
    <div
      class="page-range-display d-flex align-center min-w-0"
      :class="[{ 'is-pending': isNavigating || isInitializing }, xs ? 'text-body-2' : 'text-body-1']"
    >
      <span class="flex-shrink-0 mr-1">
        {{ pageRange.text }}
      </span>

      <template v-if="pageRange.chapter">
        <span v-if="pageRange.text" class="mx-2 opacity-60 flex-shrink-0">|</span>
        <span class="text-truncate flex-grow-1 chapter-text">
          {{ pageRange.chapter }}
        </span>
      </template>

      <div class="d-sr-only" role="status" aria-live="polite" aria-atomic="true">
        <span v-if="isNavigating || isInitializing">{{ t('book_player.label_reading_position_loading') }}</span>
        <template v-else>
          <span v-if="pageRange.text">{{ pageRange.text }}</span>
          <span v-if="pageRange.chapter">{{ pageRange.chapter }}</span>
        </template>
      </div>
    </div>

    <div v-if="isInitializing" class="status-indicator flex-shrink-0">
      <v-progress-circular v-if="isInitializing" :model-value="resolutionProgress" :size="18" :width="2" />
    </div>
  </div>
</template>

<style scoped lang="scss">
.page-range-container {
  // Ensures the container doesn't collapse
  height: 100%;
}

.is-pending {
  opacity: 0.6;
  // Optional: subtle pulse to show it's working
  animation: pulse-loading 2s infinite ease-in-out;
  pointer-events: none;
}

.chapter-text {
  max-width: clamp(100px, 30vw, 400px);
}

@keyframes pulse-loading {
  0% {
    opacity: 0.6;
  }
  50% {
    opacity: 0.4;
  }
  100% {
    opacity: 0.6;
  }
}

.min-w-0 {
  min-width: 0 !important;
}
.chapter-text {
  max-width: clamp(120px, 45vw, 400px);
}
.opacity-60 {
  opacity: 0.6;
}
</style>
